import React, { useEffect, useState } from "react";
import {
	Modal,
	Form,
	Row,
	Col,
	Overlay,
	Popover,
	Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import moment from "moment";
import { useParams } from "react-router-dom";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

const EditProject = ({
	showEditProject,
	handleCloseEditProject,
	userDataId,
	getUserCv,
	projectAllData,
}) => {
	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();
	console.log("projectAllData", projectAllData);
	console.log("userDataId", userDataId);

	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [associatedWith, setAssociatedWith] = useState("");
	const [projectUrl, setProjectUrl] = useState("");
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState(null);
	console.log("projectAllData", projectAllData);
	const [isPresent, setIsPresent] = useState(false);


	// useEffect(() => {
	// 	if (projectAllData) {
	// 		setName(projectAllData?.name);
	// 		setDescription(projectAllData?.description);
	// 		setAssociatedWith(projectAllData?.associatedWith);
	// 		setProjectUrl(projectAllData?.projectUrl);
	// 		const startDateObj = new Date(`${projectAllData.startYear}-${projectAllData.startMonth}`);
	// 		const endDateObj = new Date(`${projectAllData.endYear}-${projectAllData.endMonth}`);
	// 		setStartDate(startDateObj);
	// 		setEndDate(endDateObj);
	// 	}
	// }, [projectAllData]);

	useEffect(() => {
		if (projectAllData) {
			setName(projectAllData?.name);
			setDescription(projectAllData?.description);
			setAssociatedWith(projectAllData?.associatedWith);
			setProjectUrl(projectAllData?.projectUrl);
			const startDateObj = new Date(`${projectAllData.startYear}-${projectAllData.startMonth}`);
			let endDateObj = null;
			if (projectAllData.endYear && projectAllData.endMonth) {
				endDateObj = new Date(`${projectAllData.endYear}-${projectAllData.endMonth}`);
			}
			setStartDate(startDateObj);
			setEndDate(endDateObj);
			setIsPresent(endDateObj === null);
		}
	}, [projectAllData]);


	const [display, setDisplay] = useState(false)
	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true)
		setIsSubmitting(true); // Disable the button during submission
		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
			name: name,
			description: description,
			associatedWith: associatedWith,
			projectUrl: projectUrl,
			startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
			startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
			endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
			endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
			prjctId: projectAllData.usrDataPrjctId,
		};

		console.log("body", body);
		if (name === '' || startDate === '') {
			toast.error('Please fill all the required fields')
		} else {
			try {
				const res = await axios.post("/Resume/UpdateProject", body, {
					validateStatus: (status) => status >= 200 && status < 300, // Treat only 200-299 as success
				});
				toast.success(res.data.message);
				handleCloseEditProject();
				getUserCv();
				setName("");
				setDescription("");
				setAssociatedWith("");
				setProjectUrl("");
				setStartDate(null);
				setEndDate(null);
				setDisplay(false)
				setFormChanged(false); // Disable the button after update
			} catch (error) {
				console.error("Error Response:", error.response);
				if (error.response?.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message || "An error occurred");
				}
			}
		}
	};

	// useEffect(() => {
	// 	// ✅ Ensure isPresent is checked when endDate is null
	// 	setIsPresent(endDate === null);
	// }, [endDate]);

	// const handleCheckboxChange = (e) => {
	// 	const checked = e.target.checked;
	// 	setIsPresent(checked);
	// 	if (checked) {
	// 		setEndDate(null); // ✅ Remove end date when checked
	// 	}
	// };

	// const handleEndDateChange = (date) => {
	// 	setEndDate(date[0]); // ✅ Set end date from date picker
	// 	setIsPresent(false); // ✅ Uncheck "Is Present" when end date is selected
	// };

	return (
		<>
			<Modal
				show={showEditProject}
				onHide={handleCloseEditProject}
				centered
				size="lg"
			>
				<Modal.Header>
					<Modal.Title>Update project</Modal.Title>
					<CloseSharpIcon
						className="pointer"
						onClick={handleCloseEditProject}
					/>
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						{/* Skills Section */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="field">
								<Form.Label className="class-type">
									Name <span style={{ color: "red" }}>*</span>
								</Form.Label>
								<Form.Control
									type="text"
									className="Dark-Input-from-group"
									value={name}
									// onChange={(e) => setName(e.target.value)}
									onChange={(e) => handleFieldChange(setName, e.target.value)} // Track changes
									placeholder="Enter name"
								/>
								{display && !name ? (
									<span className="error_msg_lbl">Add project name</span>
								) : null}
							</Form.Group>
						</Col>

						<Col md={6} className="mb-2">
							<Form.Group controlId="field">
								<Form.Label className="class-type">
									Associated with
								</Form.Label>
								<Form.Control
									type="text"
									className="Dark-Input-from-group"
									value={associatedWith}
									// onChange={(e) => setAssociatedWith(e.target.value)}
									onChange={(e) => handleFieldChange(setAssociatedWith, e.target.value)} // Track changes
									placeholder="Enter  associated with"
								/>
							</Form.Group>
						</Col>


						<Col md={6} className="mb-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class Flatpickr-Calender-Class-nt">
								<Form.Label className="class-type col-md-12">Start date <span style={{ color: "red" }}>*</span>
								</Form.Label>

								<Flatpickr
									type="number"
									value={startDate}
									className="Dark-Input-from-group"
									onChange={(date) => handleFieldChange(setStartDate, date[0])} // Track changes
									placeholder="Enter start year"
									options={{
										dateFormat: "F Y", // Format: January 2025
										maxDate: new Date(), // Disable future dates
										static: true, // Keeps the calendar visible on click
										plugins: [new monthSelectPlugin({
											shorthand: false, // Full month names (January, February, etc.)
											dateFormat: "F Y",
											altFormat: "F Y"
										})],
									}}
								/>
								{display && !startDate ? (
									<span className="error_msg_lbl">Select start date </span>
								) : null}
							</Form.Group>
						</Col>
						{/* {
							// endDate === null ?
								<Col md={6} className="mb-2">
									<div className="mt-4">
										<Form.Check
											type="checkbox"
											label="Is Present"
											checked={true}
										// onChange={handleCheckboxChange}
										/>
									</div>
								</Col>
								// : ""
						} */}


						{/* <Col md={6} className="mb-2">
							<Form.Group controlId="endYear" className=" Flatpickr-Calender-Class  Flatpickr-Calender-Class-nt">
								<Form.Label className="class-type col-md-12">End Date
								</Form.Label>

								<Flatpickr
									type="number"
									value={endDate}
									className="Dark-Input-from-group"
									onChange={(date) => handleFieldChange(setEndDate, date[0])} // Track changes
									placeholder="Enter End Year"
									options={{
										dateFormat: "F Y", // Format: January 2025
										maxDate: new Date(), // Disable future dates
										static: true, // Keeps the calendar visible on click
										plugins: [new monthSelectPlugin({
											shorthand: false, // Full month names (January, February, etc.)
											dateFormat: "F Y",
											altFormat: "F Y"
										})],
									}}
								/>


							
							</Form.Group>
						</Col> */}

						<Col md={6} className="d-flex align-items-center mb-2">
							<Form.Check
								type="checkbox"
								label="Is Present"
								checked={isPresent}
								onChange={(e) => setIsPresent(e.target.checked)}
							/>
						</Col>

						{isPresent === false ? (
							<Col md={6} className="mb-2">
								<Form.Group controlId="endYear" className="Flatpickr-Calender-Class Flatpickr-Calender-Class-nt">
									<Form.Label className="class-type col-md-12">End date</Form.Label>
									<Flatpickr
										type="number"
										value={endDate}
										className="Dark-Input-from-group"
										onChange={(date) => handleFieldChange(setEndDate, date[0], "endDate")}
										placeholder="Enter end year"
										options={{
											dateFormat: "F Y",
											maxDate: new Date(),
											static: true,
											plugins: [new monthSelectPlugin({
												shorthand: false,
												dateFormat: "F Y",
												altFormat: "F Y"
											})],
										}}
									/>
								</Form.Group>
							</Col>
						) : (
							""
						)}




						<Col md={12} className="mb-2">
							<Form.Group controlId="field">
								<Form.Label className="class-type">
									Project url 
								</Form.Label>
								<Form.Control
									type="text"
									className="Dark-Input-from-group"
									value={projectUrl}
									 onChange={(e) => setProjectUrl(e.target.value)}
									//onChange={(e) => handleFieldChange(setProjectUrl, e.target.value)} // Track changes
									placeholder="Enter project url"
								/>
								{/* {display && !projectUrl ? (
									<span className="error_msg_lbl">Add Project Url </span>
								) : null} */}
							</Form.Group>
						</Col>

						<Col md={12} className="mb-2">
							<Form.Group controlId="field">
								<Form.Label className="class-type">
									Description
								</Form.Label>
								<textarea
									type="text"
									className="Dark-Input-from-group"
									value={description}
									 onChange={(e) => setDescription(e.target.value)}
									//onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
									placeholder="Enter description"
								/>
							</Form.Group>
						</Col>
					</Row>

					{/* Submit Button */}
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<div className="khojPrimaryBtn ms-3"
						onClick={handleSubmit}
						style={{ cursor: "pointer" }}
						>
							<a href="#/"
								// className=""
								// onClick={handleSubmit}
							// className={`btn ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
							// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
							// style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
							>
								Update
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default EditProject;
